<template>
    <div :class="['rounded-lg', intentClass, emphasisClass]">
        <slot name="icon">
            <component
                :is="iconComponent"
                v-if="iconComponent"
                weight="bold"
                class="size-5 shrink-0 text-subtle"
                aria-hidden="true" />
        </slot>
        <slot />
    </div>
</template>

<script>
import { PhWarning, PhWarningCircle, PhCheckCircle, PhInfo } from '@phosphor-icons/vue';

const INTENT_CLASS = {
    neutral: 'intent-neutral',
    accent: 'intent-accent',
    brand: 'intent-brand',
    info: 'intent-info',
    success: 'intent-success',
    warning: 'intent-warning',
    danger: 'intent-danger',
};

const EMPHASIS_CLASS = {
    subtle: 'emphasis-subtle',
    subtler: 'emphasis-subtler',
    normal: 'emphasis-normal',
    strong: 'emphasis-strong',
    inverted: 'emphasis-inverted',
    raised: 'emphasis-raised',
    sunken: 'emphasis-sunken',
    floating: 'emphasis-floating',
    overlay: 'emphasis-overlay',
};

const INTENT_ICONS = {
    danger: PhWarningCircle,
    warning: PhWarning,
    success: PhCheckCircle,
    info: PhInfo,
    accent: PhInfo,
    neutral: PhInfo,
    brand: PhInfo,
};

export default {
    name: 'CalloutV2',
    props: {
        intent: { type: String, default: 'neutral', validator: (value) => value in INTENT_CLASS },
        emphasis: { type: String, default: 'subtle', validator: (value) => value in EMPHASIS_CLASS },
        icon: { type: Boolean, default: false },
    },
    computed: {
        intentClass() {
            return INTENT_CLASS[this.intent];
        },
        emphasisClass() {
            return EMPHASIS_CLASS[this.emphasis];
        },
        iconComponent() {
            return this.icon ? INTENT_ICONS[this.intent] : null;
        },
    },
};
</script>
